import React from 'react';
import { formatApiDate } from '../../utils/date';

const labels = { creando: 'Procesando', pendiente: 'Pendiente', cancelando: 'Cancelando',
  aprobado: 'Aprobado', rechazado: 'Rechazado', cancelado: 'Cancelado', expirado: 'Expirado', revision: 'Revisión' };

const terminalNames = {
  NEWLAND_N950__N950NCD400224068: 'Posnet #1',
  NEWLAND_N950__N950NCD400230282: 'Posnet #2',
};

export default function PointCobroControls({ point }) {
  const c = point.cobro;
  return (
    <div className="space-y-3">
      <select aria-label="Posnet" value={point.terminalId}
        onChange={e => point.seleccionarTerminal(e.target.value)}
        disabled={point.loading || point.recovering || c?.activo}
        className="w-full min-w-0 px-3 py-2 border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent">
        <option value="">Posnet</option>
        {point.terminales.map(t => <option key={t.id} value={t.id} disabled={!t.disponible && c?.terminalId !== t.id}>
          {terminalNames[t.id] || `${t.id.split('__').pop()} · ${t.cajaId} · ${t.sucursalId}`}
        </option>)}
      </select>
      <select aria-label="QR o tarjeta" value={point.medioPago || 'all'}
        onChange={e => point.seleccionarMedio(e.target.value)}
        disabled={point.loading || point.recovering || c?.activo}
        className="w-full min-w-0 px-3 py-2 border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent">
        <option value="all">QR o tarjeta</option>
        <option value="qr">QR</option>
        <option value="debit_card">Tarjeta de débito</option>
        <option value="credit_card">Tarjeta de crédito</option>
      </select>
      {c && <div className="flex flex-wrap items-center gap-3 rounded-lg border bg-slate-50 px-3 py-3" role="status">
        <span className={`rounded-full px-3 py-1 text-sm font-medium ${c.aprobado ? 'bg-emerald-100 text-emerald-800' : 'bg-slate-200 text-slate-800'}`}>
          {labels[c.estado] || c.estado}
        </span>
        <span className="text-sm tabular-nums">${Number(c.monto).toFixed(2)}</span>
        {c.fechaPago && <span className="text-sm">{formatApiDate(c.fechaPago)}</span>}
        {c.activo && <button type="button" onClick={point.cancelar} disabled={point.loading || c.cancelacionSolicitada}
          className="ml-auto rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm disabled:opacity-50">Cancelar</button>}
      </div>}
      {(point.error || c?.incidencia || c?.cancelacionError) && <p role="alert" className="text-sm text-red-700 break-words">{point.error || c.incidencia || c.cancelacionError}</p>}
    </div>
  );
}
